module Client.Home.UpdateTelephoneNumber

open System
open Elmish
open Client
open Shared
open Illy.SafeStack
open Illy.SafeStack.Client
open Fable.React 
open Shared.Home.UpdateTelephoneNumber

type Model = 
    {
        OldNumber: string option
        TelephoneNumber: Text.Model
        Password: Text.Model
        Saving: bool
    }

let toDTO (model: Model) = 
    {
        TelephoneNumber = Text.toString model.TelephoneNumber
        Password = Text.toString model.Password
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Shared.Home.UpdateTelephoneNumber.Validations

    let resetValidations (model: Model) = 
        {model with 
            TelephoneNumber = Text.resetValidations model.TelephoneNumber
            Password = Text.resetValidations model.Password
        }

    let dispatchValidations model = 
        let model = resetValidations model 
        function 
        | ValidationResult.Passed -> model 
        | ValidationResult.Warned _ -> failwith "Did not expect warnings"
        | ValidationResult.Failed (err, _) ->
            let errors = 
                err 
                |> ValidationInfrastructure.bundleValidations 
                    (fun x -> 
                        (match x with 
                        | TelephoneNumberValidations _ -> 0 
                        | PasswordValidations _ -> 1), UpdateNumberValidations.toString x)
                    2
            {model with 
                TelephoneNumber = Text.setValidations model.TelephoneNumber errors.[0] None
                Password = Text.setValidations model.Password errors.[1] None
            }

type Msg = 
    | ApiError of ApiError
    | SaveResult of ROP.Result<ClientSideUser, FailureReason>
    | TelephoneNumberMsg of Text.Msg
    | PasswordMsg of Text.Msg
    | CloseOverlay  
    | SaveClicked 

type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | SaveSuccessful of ClientSideUser * notification: string

module Initialisations = 
    let initTelephoneNumber value =
        Text.CustomSettings.defaultOptions()
        |> Text.init "TelephoneNumber" "New Telephone Number" (Some "Enter Telephone Number") 50. true value

    let initPassword value =
        {Text.CustomSettings.defaultOptions() with TextType = Text.TextType.Password}
        |> Text.init "Password" "Password" (Some "Enter Password") 250. true value

let init() =
    let u = Storage.get<ClientSideUser> Storage.USER_STORAGE_KEY
    {
        OldNumber = u.Telephone
        TelephoneNumber = Initialisations.initTelephoneNumber None
        Password = Initialisations.initPassword None
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | TelephoneNumberMsg cMsg ->
        let m, c = Text.update cMsg model.TelephoneNumber
        {model with TelephoneNumber = m}, Cmd.map TelephoneNumberMsg c |> SideEffect.Cmd
    | PasswordMsg cMsg ->
        let m, c = Text.update cMsg model.Password
        {model with Password = m}, Cmd.map PasswordMsg c |> SideEffect.Cmd
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        let dto = toDTO model 
        let vResult = Validations.validateDTO model.OldNumber dto
        if Validation.isSuccessful false vResult then 
            {model with Saving = true},
            Api.secureCall<IUpdateTelephoneNumberApi,_,_,_> SecuredRoute.Standard (fun api -> api.updateNumber) dto SaveResult Msg.ApiError
            |> SideEffect.Cmd
        else 
            Validations.dispatchValidations model vResult, SideEffect.none
    | SaveResult reason -> 
        match reason with 
        | ROP.Success u -> model, (u, "Telephone number was updated successfully.") |> Event.SaveSuccessful |> SideEffect.Event
        | ROP.Failure (FailedValidations v) ->
            Validations.dispatchValidations {model with Saving = false} v, SideEffect.none

let view model dispatch = 
    jQueryUI.modal "Update Phone Number" 50 Msg.CloseOverlay dispatch (Some 600) [
        p [] [
            str "Your current phone number is: "
            b [] [
                model.OldNumber |> Option.defaultValue "(No Phone Number)" |> str
            ]
            
        ]
        Text.text false model.TelephoneNumber (TelephoneNumberMsg >> dispatch)
        Text.text false model.Password (PasswordMsg >> dispatch)

        yield! UI.saveControls (Some "Update phone number") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]